import styled from '@emotion/styled';

export const GradientInfoCardStyled = styled.div`
	display: flex;
	padding: 24px;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;

	border-radius: 16px;
	border: 1px solid rgba(5, 42, 128, 0.1);
	background: radial-gradient(
			126.16% 71.21% at 46.76% 100%,
			rgba(209, 247, 233, 0.4) 0%,
			rgba(255, 255, 255, 0.4) 100%
		),
		#fff;

	> h3 {
		color: #11233a;
		font-size: 18px;
		font-family: Inter;
		font-weight: 700;
		line-height: 125%;
		letter-spacing: -0.26px;
		margin: 0;
	}
`;
